var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.375 0C1.52051 0 0 1.52051 0 3.375V9H27V3.375C27 1.52051 25.4795 0 23.625 0H3.375ZM3.375 2.25H23.625C24.2578 2.25 24.75 2.74219 24.75 3.375V6.75H2.25V3.375C2.25 2.74219 2.74219 2.25 3.375 2.25ZM0 11.25V24C0 25.6569 1.34315 27 3 27H15.75V11.25H0ZM18 11.25V27H24C25.6569 27 27 25.6569 27 24V11.25H18ZM2.25 13.5H13.5V24.75H4.25C3.14543 24.75 2.25 23.8546 2.25 22.75V13.5ZM20.25 13.5H24.75V22.75C24.75 23.8546 23.8546 24.75 22.75 24.75H20.25V13.5Z",
    fill: "#FEAA2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFm);
export default __webpack_public_path__ + "static/media/FM.eb3f80a51f5ef0623124c52cbfb203a7.svg";
export { ForwardRef as ReactComponent };